// fetchDataWithPagination.ts

import { apiRequest } from "../apiHelper";
import { buildQueryString } from "../buildQueryString";
import {
  getCollegeListingCache,
  setCollegeListingCache,
} from "./collegeListingDataCache";

export async function fetchListingPageDataWithPagination(
  cacheKey: string,
  queryParams: any,
  endpoint: string
): Promise<any> {
  const inMemoryConfig = JSON.parse(
    process.env.NEXT_PUBLIC_IN_MEMORY_CACHE ?? "{}"
  );
  const shouldUseCache =
    inMemoryConfig?.NEXT_PUBLIC_IN_MEMORY_CACHE_LISTING_PAGE === "true";

  if (shouldUseCache) {
    const cachedData = getCollegeListingCache(cacheKey);
    console.log("[IN-MEMORY-CACHE] : try to get data from in memory cache");
    if (cachedData) return cachedData;
  }

  console.log(`[Cache Miss] Fetching ${endpoint} from API...`);
  const response = await apiRequest(
    `/${endpoint}?${buildQueryString(queryParams)}`,
    "GET"
  );

  const data = response?.data?.data?.results ? response.data.data : [];

  if (shouldUseCache && data.results?.length) {
    console.log("[IN-MEMORY-CACHE] : save in data in memory cache");
    setCollegeListingCache(cacheKey, data);
  }

  return data;
}
